import(/* webpackMode: "eager", webpackExports: ["V2GuideArticle"] */ "/app/apps/platform-web/components/v2/screens/V2GuideArticle.tsx");
